import { render, staticRenderFns } from "./wchgData.vue?vue&type=template&id=4645a67f&scoped=true"
import script from "./wchgData.vue?vue&type=script&lang=js"
export * from "./wchgData.vue?vue&type=script&lang=js"
import style0 from "./wchgData.vue?vue&type=style&index=0&id=4645a67f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645a67f",
  null
  
)

export default component.exports